import {
  Create,
  Box,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  FormHelperText,
} from "@pankod/refine-mui";
import { Controller, useForm } from "@pankod/refine-react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { REST_PUBLIC_URI } from "environment";
import { AxiosInstance } from "axios";
import { axiosInstance } from "@pankod/refine-simple-rest";
import { useState } from "react";

const schema = Yup.object({
  priority: Yup.number().required(),
  is_enable: Yup.boolean().required(),
});

interface formDataType {
  priority: number;
  is_enable: boolean;
  target_url: string;
}
interface data {
  url: string;
}

interface fileUpload {
  data: data;
}

const allowedExtension = ["image/jpeg", "image/jpg", "image/png"];

const upload = async (base64: File) => {
  const x = new FormData();

  x.append("file", base64);
  const httpClient: AxiosInstance = axiosInstance;
  const url = `${REST_PUBLIC_URI}/api/admin/v1/upload-file`;

  const data: fileUpload = await httpClient.post(url, x);

  return data;
};

export const BannerCreate = () => {
  const onChangeHandler = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    try {
      setError(false);
      const target = event.target;
      const file: File = (target.files as FileList)[0];
      if (!allowedExtension.includes(file.type)) {
        setError(true);
        setHelperText("Only image is allowed");
        return;
      }
      const banner_url = await upload(file);
      setValue("banner_url", banner_url.data.url, { shouldValidate: true });
    } catch (error) {
      setHelperText(error as string);
      setError(true);
    }
  };

  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    control,
    setValue,
    formState: { errors },
  } = useForm<formDataType>({ resolver: yupResolver(schema) });

  const [error, setError] = useState<boolean>(false);
  const [helperText, setHelperText] = useState<string>("Only image is allowed");

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          onChange={onChangeHandler}
          error={error}
          helperText={error ? helperText : null}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="file"
          label="File"
          name="file"
        />
        <TextField
          {...register("priority")}
          required
          error={!!(errors as any)?.priority}
          helperText={(errors as any)?.priority?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Banner Priority"
          name="priority"
        />
        <TextField
          {...register("target_url")}
          error={!!(errors as any)?.target_url}
          helperText={(errors as any)?.target_url?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="string"
          label="Banner Target URL"
          name="target_url"
        />
        <Controller
          control={control}
          name="is_enable"
          render={({ field: { onChange, value } }) => (
            <FormControl required error={!!(errors as any)?.is_enable}>
              <FormLabel>Is_Enable</FormLabel>
              <RadioGroup
                row
                onChange={(_, value) => onChange(value === "true")}
                value={value}
              >
                <FormControlLabel
                  control={<Radio />}
                  label="True"
                  value={true}
                />
                <FormControlLabel
                  control={<Radio />}
                  label="False"
                  value={false}
                />
              </RadioGroup>
              <FormHelperText>
                {(errors as any)?.is_enable?.message}
              </FormHelperText>
            </FormControl>
          )}
        />
      </Box>
    </Create>
  );
};
